import Skeleton from 'src/Admin/components/common/skeleton';

const Lists = ({
  data,
  selectChangeHandler,
  displayId = 'BlkOfBusId',
  displayLabel = 'BlkOfBusName',
  labelIdText,
  searchString,
  hasDescription = false,
  //filterFieldNames = null
}) => {
  const onChangeHandler = (e) => {
    selectChangeHandler(e);
  };

  return (
    <div className="blob-lists">
      {data ? (
        data
          .filter((d) => {
            if (!searchString) return true;
            if (displayLabel !== '' && displayId !== '') {
              if (
                d[displayLabel]
                  .toLowerCase()
                  .includes(searchString.toLowerCase()) ||
                d[displayId].toLowerCase().includes(searchString.toLowerCase())
              ) {
                return true;
              }
            }
            return;
          })
          .map((item, index) => {
            return (
              <div key={index}>
                <div className="blob-list-item-border" key={index}>
                  <div className="d-flex blob-list-item">
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        id={item[displayId]}
                        name={item[displayId]}
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => onChangeHandler(e)}
                        checked={item?.isChecked || false}
                      />{' '}
                      <span className="blob-item-name-1">
                        {item[displayLabel]}
                      </span>
                    </div>
                    {labelIdText && (
                      <div className="blob-item-name-2">
                        {labelIdText}: {item[displayId]}
                      </div>
                    )}
                  </div>
                  {hasDescription && (
                    <div className="blob-item-desc">
                      Nulla et aliquet dui, fringilla luctus enim. Nulla
                      facilisi.
                    </div>
                  )}
                </div>
              </div>
            );
          })
      ) : (
        <Skeleton count={20} height={30} />
      )}
    </div>
  );
};

export default Lists;
